// The portal's information architecture (SPEC §4, ADR 0012), one entry per
// feature area. Order = menu order = the order react-admin used to pick the
// landing page (the first area the user may list).
import type { ComponentType } from 'react'
import {
  MdOutlineExtension,
  MdOutlineGroup,
  MdOutlineNewReleases,
  MdOutlineViewModule,
  MdOutlineWaves
} from 'react-icons/md'

export interface AreaLink {
  /** Area id, as used in APP_PORTED_AREAS (ADR 0017). */
  area: string
  /** Resource for the `list` RBAC gate. */
  resource: string
  label: string
  /** Router path, react-admin's shape. */
  path: string
  icon?: ComponentType
}

/** Top-level menu items, in the portal's order (CustomLayout.tsx). */
export const MENU: AreaLink[] = [
  {
    area: 'tenants',
    resource: 'tenants',
    label: 'Tenants',
    path: '/tenants',
    icon: MdOutlineGroup
  },
  {
    area: 'releases',
    resource: 'releases',
    label: 'Releases',
    path: '/releases',
    icon: MdOutlineNewReleases
  },
  { area: 'waves', resource: 'waves', label: 'Waves', path: '/waves', icon: MdOutlineWaves },
  {
    area: 'modules',
    resource: 'modules',
    label: 'Modules',
    path: '/modules',
    icon: MdOutlineViewModule
  },
  {
    area: 'moduleversions',
    resource: 'moduleversions',
    label: 'Module versions',
    path: '/moduleversions',
    icon: MdOutlineExtension
  }
]

/** The "Status" group → "Upgrade process" panel, gated on upgradeprocess/tenants. */
export const UPGRADE_PROCESS: AreaLink[] = [
  {
    area: 'upgradeprocess',
    resource: 'upgradeprocess/tenants',
    label: 'Tenants',
    path: '/upgradeprocess/tenants'
  },
  {
    area: 'upgradeprocess',
    resource: 'upgradeprocess/releases',
    label: 'Releases',
    path: '/upgradeprocess/releases'
  }
]

/** Areas reachable without a menu entry (portal users via Settings). */
export const PORTAL_USERS: AreaLink = {
  area: 'portalusers',
  resource: 'portalusers',
  label: 'Users & Roles',
  path: '/portalusers'
}

/** Landing-page candidates, in react-admin's registration order (routes.tsx). */
export const LANDING_ORDER: AreaLink[] = [...MENU, ...UPGRADE_PROCESS, PORTAL_USERS]
